import React from "react";
import { GLOBAL_MEETING_DATA } from "../../constants/PublicVariables";
import storage from "../../services/storage";
import { LogFirebase } from "../../services/firestore";
import CenterModal from "../UI/Modal/CenterModal";
import { setConfirmDisconnectCall } from "../../reducers/common-reducer";
import { useDispatch, useSelector } from "react-redux";
import endCallService from "../../services/endCallService";
import useLanguageChange from "../../hooks/useLanguageChange";

const EndCall = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();

    const { confirmDisconnectCall } = useSelector((state) => state.commonReducer);

    const body = (
        <div className='cms-modal-text' data-testid='endCallModalBody'>
            <h4>{localisedValues?.are_you_sure_you_want_to_leave_this_call}</h4>
        </div>
    );

    const footer = (
        <>
            {GLOBAL_MEETING_DATA.isAgent && (
                <div className='dont-show-checkbox' data-testid='endCallModalFooterCheckbox'>
                    <div className='checkbox default-checkbox'>
                        <label>
                            <input type='checkbox' onChange={(e) => rememberDontShowLeavePopup(e)} id='chkDontShowLeavePopup' />
                            <span className='for-design'></span>
                            <span className='for-text'>{localisedValues?.dont_show_this_again}</span>
                        </label>
                    </div>
                </div>
            )}
            <div className='end-call-confirmation-footer-btn button-inline more-space button-inline-tb-space d-flex align-items-center'>
                <div className='button'>
                    <button className='btn default-btn-link' data-bs-dismiss='modal' onClick={() => dispatch(setConfirmDisconnectCall(false))}>
                        {localisedValues?.cancel_initcap}
                    </button>
                </div>
                <div className='button'>
                    <button
                        className='btn default-btn-primary'
                        data-testid='endCallModalFooterButton'
                        onClick={() => {
                            dispatch(setConfirmDisconnectCall(false));
                            endCallService.manageEndcall();
                        }}
                    >
                        <span className='btn-icon'>{localisedValues?.leave_lable}</span>
                    </button>
                </div>
            </div>
        </>
    );

    const rememberDontShowLeavePopup = (e) => {
        let obj = {};
        console.log(e.target.checked);
        if (e.target.checked) {
            obj[GLOBAL_MEETING_DATA.ucid] = false;
            storage.set("agentsChoiceToShowPopup", JSON.stringify(obj));
            LogFirebase("CallEndPopup", "DontShowLeaveCheckbox", "checked");
        } else {
            obj[GLOBAL_MEETING_DATA.ucid] = false;
            storage.set("agentsChoiceToShowPopup", JSON.stringify(obj));
            LogFirebase("CallEndPopup", "DontShowLeaveCheckbox", "unchecked");
        }
    };

    return (
        <CenterModal
            showModal={confirmDisconnectCall}
            modalClass='default-modal modal-small end-call-confirmation-modal'
            className='modal-dialog-centered'
            bodyClassName='default-custom-scroll'
            body={body}
            footer={footer}
            footerClassName='end-call-confirmation-footer align-items-center'
            backdrop={"static"}
            keyboard={false}
        />
    );
};

export default EndCall;
